import FormGroup from "./FormGroup";
import React, {useEffect, useState} from "react";
import {giftProcInfo, kwaFormat} from "../../utils/UtilsFunc";


const Coupon = (props:any) => {
  // console.log(props,'/[Coupon.tsx]')
  
  const {userInfo, actType, onSubmit} = props;
  const [presents, setPresents] = useState<any[]|null>(null)

  useEffect(() => {
    if (!userInfo || Object.keys(userInfo).length === 0) return

    setPresents(userInfo?.membership?.presents || null)
  }, [userInfo])

  return (
    <>
      <div className={`sec sec_3`}>
        <h3 className={`tit h3`}>내가 선물한 쿠폰</h3>
        {(!presents || presents.length === 0) && (
          <div className={`card_layout`}>
            <div className={`card_sec`}>
              <p className={`text-center body1_sb`}>선물한 쿠폰이 없어요</p>
            </div>
          </div>
        )}
        {(presents && presents.length > 0) && (
          presents.map((present:any, index:number) => (
            <div key={index} className={`card_layout`}>
              <div className={`card_sec`}>
                <h3 className={`h3`}>상품정보</h3>
                <FormGroup>
                  <FormGroup.Label>상품명</FormGroup.Label>
                  <FormGroup.Value>{present?.name}</FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>등록일</FormGroup.Label>
                  <FormGroup.Value>{present?.issued_at}</FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>쿠폰코드</FormGroup.Label>
                  <FormGroup.Value>{present?.code}</FormGroup.Value>
                </FormGroup>
              </div>
              <div className={`card_sec`}>
                <h3 className={`h3`}>결제 정보</h3>
                <FormGroup>
                  <FormGroup.Label>결제 번호</FormGroup.Label>
                  <FormGroup.Value>{present?.payment?.payment_id}</FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>결제일</FormGroup.Label>
                  <FormGroup.Value>{present?.payment?.payment_at}</FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>결제 금액</FormGroup.Label>
                  <FormGroup.Value>{kwaFormat(present?.payment?.payment_amount)}원</FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>결제 수단</FormGroup.Label>
                  <FormGroup.Value>{present?.payment?.payment_method}</FormGroup.Value>
                </FormGroup>
              </div>
            </div>
          ))
        )}
      
      </div>
    </>
  )
}
export default Coupon
